<div class="ledger-container" *appHasPermission="[{ resource: Resources.Ledger, scope: Scopes.Read }]">
  <div class="ledger-header">
    <div class="title-container">
      <div class="inner-tab-title">Ledger</div>
    </div>
  </div>
  <form class="form-container" (submit)="onGenerate($event)">
    <h3>Generate Ledger Report</h3>
    <div class="form-group date-group">
      <app-date-picker
        [datePickerMode]="'dropdown'"
        [styleDropdown]="'custom'"
        [dateFilter]="dateFilter"
        (rangeChange)="onDateRangeSelected($event)"
      ></app-date-picker>
    </div>
    @if(isSettlementApp){
    <div class="form-group date-group" style="position: relative">
      <app-dropdown
        label="Merchant"
        placeholder="Select merchant"
        [options]="merchantOptions"
        [(ngModel)]="selectedMerchant"
        name="merchant"
      />
    </div>
    }
    <div class="form-group">
      <app-dropdown
        label="Currencies"
        placeholder="Select Currencies"
        [options]="currencyOptions"
        [(ngModel)]="selectedCurrencies"
        name="currencies"
        type="checkbox"
      />
    </div>
    <app-button
      *appHasPermission="{ resource: Resources.Reports, scope: Scopes.Export }"
      buttonVariant="report-export"
      buttonType="submit"
      [state]="generateButtonState"
    >
      <img src="shared-assets/icons/download.png" alt="Export Icon" class="icon" />
      <span>Generate</span>
    </app-button>
  </form>
</div>
